import { Component, createRef } from 'react';
import { Popup } from 'devextreme-react';
import { EditMemberForm } from './edit-member-form';
import {
  CreateAuthorizedStore,
} from '~/helpers/data';
import { appConst } from '~/app-const';

const schoolsUrl = `${window.env.apiEndpoint}/api/v1/Schools`;

export class EditMemberPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      popupTitle: 'Loading...',
    };

    this.provincesData = CreateAuthorizedStore({ loadUrl: `${schoolsUrl}/provincesLookup` }, null, 'Value');
    this.updateTitle = this.updateTitle.bind(this);

    this.editMemberFormRef = createRef();
    this.editMemberFormPopupRef = createRef();
  }

  updateTitle(newTitle) {
    this.setState({ popupTitle: newTitle || "Unable to show" });
  }
  renderMemberEditPopUp(isEditFormShown) {
    const {
      rowMemberData,
      memberAddNewMode,
      hideMemberEditPopupAndRefreshGrid,
      hideMemberEditPopup,
    } = this.props;

    if (isEditFormShown) {
      const { membersLookupData, selectedTabIndex } = this.props;
      return (
        <Popup
          ref={this.editMemberFormPopupRef}
          title={this.state.popupTitle}
          visible={isEditFormShown}
          onHiding={(e) => {
            e.cancel = true;
            this.editMemberFormRef && this.editMemberFormRef.current && this.editMemberFormRef.current.cancelData();
          }}
          {...appConst.defaultPopupOptions}
        >
          <EditMemberForm
            ref={this.editMemberFormRef}
            rowData={rowMemberData}
            hideEditPopupAndRefreshGrid={hideMemberEditPopupAndRefreshGrid}
            hideEditPopup={hideMemberEditPopup}
            salutationsData={membersLookupData.salutationsData}
            gendersData={membersLookupData.gendersData}
            pronounsData={membersLookupData.pronounsData}
            emailAddressTypesData={membersLookupData.emailAddressTypesData}
            phoneTypesData={membersLookupData.phoneTypesData}
            membershipTypesData={membersLookupData.membershipTypesData}
            employmentStatusesData={membersLookupData.employmentStatusesData}
            contractTypesData={membersLookupData.contractTypesData}
            designationsData={membersLookupData.designationsData}
            ridingsData={membersLookupData.ridingsData}
            addNewMode={memberAddNewMode}
            provincesData={membersLookupData.provincesData}
            updateTitle={this.updateTitle}
            selectedTabIndex={selectedTabIndex}
          />
        </Popup>
      );
    }
  }

  render() {
    const { showMemberEditForm } = this.props;
    return (
      <>
        {this.renderMemberEditPopUp(showMemberEditForm)}
      </>
    );
  }
}
